<span class="snackbar">{{ data | translate }}</span>